import { ACCESS_TOKEN_COOKIE_NAME } from "@/utils/request";
import { CSRF_TOKEN_COOKIE_NAME } from "@/constants";
import * as mutations from "./mutation-types";
import cookies from "@/storage/cookies";
import helpers from "@/utils/helpers";
import request from "@/utils/request";
import TagManager from "@/services/TagManager";
import api from "@/api";

export const checkUsername = async ({ commit }, username) => {
  commit(mutations.SET_LOGIN_USERNAME, username);
  commit(mutations.RESET_LOGIN_EXTRA_INFO);

  try {
    const res = await api.security.checkUsername(username);
    const { firstName, lastName, avatarUrl } = res.data;

    commit(mutations.SET_LOGIN_FULLNAME, { firstName, lastName });
    commit(mutations.SET_LOGIN_AVATAR_URL, avatarUrl);

    return res;
  } catch (e) {
    const data = helpers.get(e, "response.data");
    if (data && data.id) {
      const {
        firstName,
        lastName,
        birthday,
        gender,
        isSubscribed,
        phoneNumber,
      } = data;
      commit(mutations.SET_LOGIN_EXTRA_INFO, {
        firstName,
        lastName,
        birthday,
        gender,
        subscribed: isSubscribed,
        phoneNumber,
      });
    }

    throw e;
  }
};

export const resetLoginExtraInfo = ({ commit }) => {
  commit(mutations.RESET_LOGIN_EXTRA_INFO);
};

export const loginByUsername = async ({ commit }, { username, password }) => {
  commit(mutations.SET_LOGIN_USERNAME, username);

  let res = await api.security.loginByUsername(username, password);

  cookies.set(ACCESS_TOKEN_COOKIE_NAME, res.data.accessToken, { expires: 30 });
  request.setAccessToken(res.data.accessToken);
  commit(mutations.SET_CURRENT_USER, res.data.customer);

  TagManager.pushEvent("login", {
    type: "user",
    id: res.data.customer.id,
  });

  return res;
};

export const loginByFacebook = async () => {
  const { protocol, host } = window.location;
  const destination = `${protocol}//${host}/account`;

  window.location = `https://bv.devel/connect/facebook?_destination=${destination}`;
};

export const clearSession = async ({ commit }) => {
  cookies.remove(ACCESS_TOKEN_COOKIE_NAME);
  cookies.remove(CSRF_TOKEN_COOKIE_NAME);
  request.removeAccessToken();

  commit(mutations.RESET_CURRENT_USER);
  commit(mutations.RESET_LOGIN_EXTRA_INFO);
};

export const logout = async ({ dispatch }) => {
  return new Promise(() => {
    const token = cookies.get(ACCESS_TOKEN_COOKIE_NAME);

    api.security.logout({ token: token });
    dispatch("clearSession");
  });
};

export const checkSession = async ({ commit }) => {
  let res = await api.security.checkSession();

  commit(mutations.SET_CURRENT_USER, res.data.customer);
  return res;
};
